export const ageSliderDictionary = {
    0: 7, // for "8 and under"
    1: 8,
    2: 9,
    3: 10,
    4: 11,
    5: 12,
    6: 13,
    7: 14,
    8: 15,
    9: 16,
    10: 17,
    11: 18,
    12: 21,
    13: 25,
    14: 30,
    15: 35,
    16: 40,
    17: 45,
    18: 50,
    19: 55,
    20: 60,
    21: 65,
    22: 70,
    23: 71, // for "70 and over"
};

export const eventDivisionAgeSliderDictionary = {
    0: 5, // for "6 and under"
    1: 6,
    2: 7,
    3: 8,
    4: 9,
    5: 10,
    6: 11,
    7: 12,
    8: 13,
    9: 14,
    10: 15,
    11: 16,
    12: 17,
    13: 18,
    14: 19,
    15: 20,
    16: 21,
    17: 22,
    18: 23,
    19: 24,
    20: 25,
    21: 26,
    22: 27,
    23: 28,
    24: 29,
    25: 30,
    26: 31,
    27: 32,
    28: 33,
    29: 34,
    30: 35,
    31: 36,
    32: 37,
    33: 38,
    34: 39,
    35: 40,
    36: 41,
    37: 42,
    38: 43,
    39: 44,
    40: 45,
    41: 46,
    42: 47,
    43: 48,
    44: 49,
    45: 50,
    46: 51,
    47: 52,
    48: 53,
    49: 54,
    50: 55,
    51: 56,
    52: 57,
    53: 58,
    54: 59,
    55: 60,
    56: 61,
    57: 62,
    58: 63,
    59: 64,
    60: 65,
    61: 66,
    62: 67,
    63: 68,
    64: 69,
    65: 70,
    66: 71,
    67: 72,
    68: 73,
    69: 74,
    70: 75,
    71: 76,
    72: 77,
    73: 78,
    74: 79,
    75: 80,
    76: 81,
    77: 82,
    78: 83,
    79: 84,
    80: 85,
    81: 90,
    82: 95,
    83: 99,
    84: 100, // for "99 and over"
};

export const minUtrValue = 1;

export const maxUtrValue = 16;

export const minUtrpValue = 1;

export const minUtrpBucket = 'P1';

export const maxUtrpValue = 10;

function getNumericKeyByValueFromDictionary(value, dictionary) {
    const keys = Object.keys(dictionary);
    const maxKey = keys.length - 1;
    const maxValue = dictionary[maxKey];
    const minValue = dictionary[0];
    let result;

    // handle values outside the range
    if (value < minValue) {
        result = 0;
    } else if (value > maxValue) {
        result = maxKey;
    } else {
        // handle values within the range, fallback to 1 if there is no match
        const foundKey = keys.find(key => dictionary[key] === value);
        result = foundKey !== undefined ? parseInt(foundKey, 10) : 1;
    }
    return result;
}

export function getAgeKeyByValue(value) {
    return getNumericKeyByValueFromDictionary(value, ageSliderDictionary);
}

export function getEventDivisionAgeKeyByValue(value) {
    return getNumericKeyByValueFromDictionary(value, eventDivisionAgeSliderDictionary);
}

export const ageDisplay = (value) => {
    const startRange = parseInt(getAgeKeyByValue(value[0]));
    const endRange = parseInt(getAgeKeyByValue(value[1]));

    if (startRange === 1 && endRange === Object.keys(ageSliderDictionary).length - 2) {
        return 'All';
    }
    if (startRange === 1) {
        return `${ageSliderDictionary[endRange]} and Under`;
    }
    if (endRange === Object.keys(ageSliderDictionary).length - 2) {
        return `${ageSliderDictionary[startRange]} and Over`;
    }
    return `${ageSliderDictionary[startRange]} to ${ageSliderDictionary[endRange]}`;
};

export const getEventAgeDisplay = (value) => {
    const [startRange, endRange] = value;
    if (startRange === 0 && endRange === Object.keys(eventDivisionAgeSliderDictionary).length - 1) {
        return 'All';
    }
    if (startRange === endRange && startRange === 0) {
        return `${eventDivisionAgeSliderDictionary[1]} and Under`;
    }
    if (startRange === endRange && endRange === Object.keys(eventDivisionAgeSliderDictionary).length - 1) {
        return `${eventDivisionAgeSliderDictionary[endRange - 1]} and Over`;
    }
    if (startRange === endRange) {
        return `Age ${eventDivisionAgeSliderDictionary[startRange]} Only`;
    }
    if (startRange === 0) {
        return `${eventDivisionAgeSliderDictionary[endRange]} and Under`;
    }
    if (endRange === Object.keys(eventDivisionAgeSliderDictionary).length - 1) {
        return `${eventDivisionAgeSliderDictionary[startRange]} and Over`;
    }
    return `${eventDivisionAgeSliderDictionary[startRange]} to ${eventDivisionAgeSliderDictionary[endRange]}`;
};

// Age thresholds intentionally differ by surface — they are NOT the same product rule.
//
// collegeRecruitingPlayerAgeMin / collegeRecruitingPlayerAgeMax (12–18) bound the
// audience that college club owners are allowed to recruit (i.e. when a coach
// views any player in the platform, the Student Info tab only surfaces for
// junior-recruiting-aged players in this range).
//
// collegeRecruitingOwnProfileStudentTabAgeMax (23) extends the window for
// own-profile so users can still manage their own student info while in college.
//
// collegeProspectMaxAge (25) is the cap for the College Prospect Portal (CPP)
// feature, which is a distinct power-subscription product gated by Statsig and
// targeted at a broader prospect audience than coach-facing recruiting.
export const collegeRecruitingPlayerAgeMin = 12;

export const collegeRecruitingPlayerAgeMax = 18;

export const collegeRecruitingOwnProfileStudentTabAgeMax = 23;

export const collegeProspectMaxAge = 25;

export const eventCreateSteps = {
    STEPS_4: 4,
    STEPS_5: 5,
    STEPS_6: 6,
};

export const LocationTypeIds = {
    PRIMARY: 1,
    SECONDARY: 2,
};

export const collegeRecruitingAgeSliderDictionary = { 1: 12, 2: 13, 3: 14, 4: 15, 5: 16, 6: 17, 7: 18 };

export function getCollegeRecruitingAgeKeyByValue(value) {
    return Object.keys(collegeRecruitingAgeSliderDictionary).find(key => collegeRecruitingAgeSliderDictionary[key] === value);
}

export const monthOptions =
    [
        { id: 1, label: 'January' },
        { id: 2, label: 'February' },
        { id: 3, label: 'March' },
        { id: 4, label: 'April' },
        { id: 5, label: 'May' },
        { id: 6, label: 'June' },
        { id: 7, label: 'July' },
        { id: 8, label: 'August' },
        { id: 9, label: 'September' },
        { id: 10, label: 'October' },
        { id: 11, label: 'November' },
        { id: 12, label: 'December' },
    ];

export const daysPerMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const drawSizes = (label) => [
    { id: '2', label: `2 ${label} / 1 match` },
    { id: '4', label: `4 ${label} / 2 matches` },
    { id: '8', label: `8 ${label} / 4 matches` },
    { id: '16', label: `16 ${label} / 8 matches` },
    { id: '32', label: `32 ${label} / 16 matches` },
    { id: '64', label: `64 ${label} / 32 matches` },
    { id: '128', label: `128 ${label} / 64 matches` },
];

export const ficOrFibDrawSizes = (label) => [
    { id: '16', label: `16 ${label} / 8 matches` },
    { id: '32', label: `32 ${label} / 16 matches` },
    { id: '64', label: `64 ${label} / 32 matches` },
    { id: '128', label: `128 ${label} / 64 matches` },
];

export const drawSizesMP = () => [
    { id: '2', label: `1 match` },
    { id: '4', label: `2 matches` },
    { id: '6', label: `3 matches` },
    { id: '8', label: `4 matches` },
    { id: '10', label: `5 matches` },
    { id: '12', label: `6 matches` },
    { id: '14', label: `7 matches` },
    { id: '16', label: `8 matches` },
    { id: '18', label: `9 matches` },
    { id: '20', label: `10 matches` },
    { id: '22', label: `11 matches` },
    { id: '24', label: `12 matches` },
    { id: '26', label: `13 matches` },
    { id: '28', label: `14 matches` },
    { id: '30', label: `15 matches` },
    { id: '32', label: `16 matches` },
    { id: '34', label: `17 matches` },
    { id: '36', label: `18 matches` },
    { id: '38', label: `19 matches` },
    { id: '40', label: `20 matches` },
    { id: '42', label: `21 matches` },
    { id: '44', label: `22 matches` },
    { id: '46', label: `23 matches` },
    { id: '48', label: `24 matches` },
    { id: '50', label: `25 matches` },
    { id: '52', label: `26 matches` },
    { id: '54', label: `27 matches` },
    { id: '56', label: `28 matches` },
    { id: '58', label: `29 matches` },
    { id: '60', label: `30 matches` },
    { id: '62', label: `31 matches` },
    { id: '64', label: `32 matches` },
];

export const drawSizesCompass = (label) => [
    { id: '8', label: `8 ${label}` },
    { id: '16', label: `16 ${label}` },
];

export const drawSizesRR = (label) => [
    { id: '2', label: `2 ${label} / 1 match` },
    { id: '3', label: `3 ${label} / 2 matches` },
    { id: '4', label: `4 ${label} / 3 matches` },
    { id: '5', label: `5 ${label} / 4 matches` },
    { id: '6', label: `6 ${label} / 5 matches` },
    { id: '7', label: `7 ${label} / 6 matches` },
    { id: '8', label: `8 ${label} / 7 matches` },
    { id: '9', label: `9 ${label} / 8 matches` },
    { id: '10', label: `10 ${label} / 9 matches` },
];

export const transparentPng = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export const stripePlans = {
    members: {
        powerAnnual: 'power_annual_v2022',
        powerMonthly: 'power_monthly_v2022',
    },
    clubs: {
        pro: 'proclub_college_annual_v2022',
        proCollege: 'proclub_college_annual_v2022',
        premiumMonthly: 'premium_club_monthly_v1',
        premiumAnnual: 'premium_club_annual_v1',
        premiumTenMonthly: 'premium_ten_club_monthly',
        premiumTenAnnual: 'premium_ten_club_annual',
        performanceHsClub: 'performance_hs_club_v2024',
    },
};

export const stripeCoupons = {
    proTennisMonthlyDiscount: 'PTT - $2 Subscription',
    proTennisYearlyDiscount: 'PTT One-Time Annual Discount',
};

export const paymentIconsDictionary = {
    visa: '1.png',
    paypal: '3.png',
    mastercard: '2.png',
    discover: '14.png',
    'american express': '22.png',

    amex: '22.png',
    diners: '10.png',
    jcb: '16.png',
    unionpay: '25.png',
};

export const nonPoweredPlayerDefaultDivisionFee = 10;

export const supportedPlayerStudentFileTypes = ['pdf', 'doc', 'docx', 'rtf', 'txt', 'ppt', 'pptx'];

export const supportedPlayerStudentFileTypesAcceptsString =
    `${'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,'}
    ${'application/rtf,text/plain,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation'}`;

export const supportedPlayerStudentFileTypesForInfoButton = `Supported file types: ${supportedPlayerStudentFileTypes.join(', ')}`;

export const proTennisPowerContent = {
    title: 'NOTE TO PRO TENNIS TOUR PLAYERS',
    subtitle: 'Upgrading to a Power subscription is required for you to be able to enter unlimited UTR Pro Tennis Tour Tournaments for the next 12 months. In addition, you’ll be able to:',
    bulletpoints: [
        'See the detailed 2 decimal UTR Rating for ALL players, not just you',
        'View advanced match results metrics',
        'Receive invitations to future Pro events',
        'Receive communication from UTR Sports on your agreement, draws, withdrawals, payment of prize money and so on',
    ],
    info: 'Click the Upgrade button to continue.  After Upgrade, you’ll receive a Docusign package via email from us.',
};

export const supportedEventAttachmentFileTypes = ['pdf', 'doc', 'docx', 'xls', 'xlsx'];
export const supportedEventAttachmentFileTypesAcceptsString =
    `${'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,'}
    ${'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,'}`;

export const PTT_EVENT_TOUR_ID = 'ac2a49a9-d7a4-4a5a-8884-c957e1fe23cc';

export const minimumVerifiedParticipants = 4;

export const LeagueSessionTypes = {
    TEAM_TOURNAMENT: 1,
    MULTI_ROUND: 2,
};

export const sessionTypes = [
    { id: 0, description: 'All' },
    { id: LeagueSessionTypes.TEAM_TOURNAMENT, description: 'Team Tournament' },
    { id: LeagueSessionTypes.MULTI_ROUND, description: 'Multi-Round' },
];

export const responseStatusTypes = {
    OK: 200,
    OK_NO_CONTENT: 204,
};

export const stripeCheckoutFormText = {
    sub_text_form: 'Enter payment detail below.',
    sub_text_payment_methods: 'Select a saved payment option below or add a new one.',
    powered_title: 'Upgrade to <span>Power</span>',
    cc_update_title: 'Update Your Payment Details',
    default_card_page_title: 'Payment',
};

export const TennisScoringFormatTypes = {
    BEST_OF_THREE: 1,
    TWO_SETS_WITH_TIEBREAKER: 2,
    SINGLE_SET: 3,
    TIME_BASED: 4,
    FAST_FOUR: 5,
};

export const PickleballScoringFormatTypes = {
    SINGLE_GAME: 6,
    BEST_OF_THREE_GAMES: 7,
    TIME_BASED_GAME: 8,
    GAME_TO_11_WIN_BY_2: 9,
    GAME_TO_15_WIN_BY_2: 10,
    GAME_TO_15_WIN_BY_2_RALLY: 11,
    GAME_TO_21_WIN_BY_2: 12,
    GAME_TO_21_WIN_BY_2_RALLY: 13,
    BEST_OF_3_GAMES_TO_11_WIN_BY_2: 14,
    BEST_OF_3_GAMES_TO_15_WIN_BY_2: 15,
    GAME_TO_11_WIN_BY_1: 16,
    GAME_TO_15_WIN_BY_1: 17,
    GAME_TO_15_WIN_BY_1_RALLY: 18,
    GAME_TO_21_WIN_BY_1: 19,
    GAME_TO_21_WIN_BY_1_RALLY: 20,
    BEST_OF_3_GAMES_TO_11_WIN_BY_1: 21,
    BEST_OF_3_GAMES_TO_15_WIN_BY_1: 22,
};

export const tennisScoringSetTypes = [
    { id: TennisScoringFormatTypes.BEST_OF_THREE, description: 'Best of Three Sets' },
    { id: TennisScoringFormatTypes.TWO_SETS_WITH_TIEBREAKER, description: 'Two Sets w/ Match Tiebreaker' },
    { id: TennisScoringFormatTypes.SINGLE_SET, description: 'Single Set' },
    { id: TennisScoringFormatTypes.TIME_BASED, description: 'Time Based' },
    { id: TennisScoringFormatTypes.FAST_FOUR, description: 'Fast Four' },
];

export const pickleballScoringGameTypes = [
    { id: PickleballScoringFormatTypes.SINGLE_GAME, description: 'Single Game' },
    { id: PickleballScoringFormatTypes.BEST_OF_THREE_GAMES, description: 'Best of Three Games' },
    { id: PickleballScoringFormatTypes.TIME_BASED_GAME, description: 'Time Based' },
    { id: PickleballScoringFormatTypes.GAME_TO_11_WIN_BY_2, description: '1 game to 11 win by 2' },
    { id: PickleballScoringFormatTypes.GAME_TO_15_WIN_BY_2, description: '1 game to 15 win by 2' },
    { id: PickleballScoringFormatTypes.GAME_TO_15_WIN_BY_2_RALLY, description: '1 game to 15 win by 2 (rally)' },
    { id: PickleballScoringFormatTypes.GAME_TO_21_WIN_BY_2, description: '1 game to 21 win by 2' },
    { id: PickleballScoringFormatTypes.GAME_TO_21_WIN_BY_2_RALLY, description: '1 game to 21 win by 2 (rally)' },
    { id: PickleballScoringFormatTypes.BEST_OF_3_GAMES_TO_11_WIN_BY_2, description: '2 of 3 games to 11 win by 2' },
    { id: PickleballScoringFormatTypes.BEST_OF_3_GAMES_TO_15_WIN_BY_2, description: '2 of 3 games to 15 win by 2' },
    { id: PickleballScoringFormatTypes.GAME_TO_11_WIN_BY_1, description: '1 game to 11 win by 1' },
    { id: PickleballScoringFormatTypes.GAME_TO_15_WIN_BY_1, description: '1 game to 15 win by 1' },
    { id: PickleballScoringFormatTypes.GAME_TO_15_WIN_BY_1_RALLY, description: '1 game to 15 win by 1 (rally)' },
    { id: PickleballScoringFormatTypes.GAME_TO_21_WIN_BY_1, description: '1 game to 21 win by 1' },
    { id: PickleballScoringFormatTypes.GAME_TO_21_WIN_BY_1_RALLY, description: '1 game to 21 win by 1 (rally)' },
    { id: PickleballScoringFormatTypes.BEST_OF_3_GAMES_TO_11_WIN_BY_1, description: '2 of 3 games to 11 win by 1' },
    { id: PickleballScoringFormatTypes.BEST_OF_3_GAMES_TO_15_WIN_BY_1, description: '2 of 3 games to 15 win by 1' },
];

export const subscriptionTypes = {
    CPP: 'CPP',
};

export const ratingMatchTypeDisplay = {
    singles: 'SGLS',
    doubles: 'DBLS',
};

export const GLOBAL_PLAYER_RANKINGS_TITLE = 'Global player rankings';
export const TABS_GENDER = [
    { name: 'M', value: 'm', default: true },
    { name: 'F', value: 'f' },
];
export const DEFAULT_FILTERS = {
    gender: 'm',
    level: 'Pro',
};

export const GENDER_MALE = 'm';
export const GENDER_FEMALE = 'f';
export const GENDER_FILTER_ALL = 'all';

export const GenderFilterTypes = {
    ALL: 'all',
    MALE: 'm',
    FEMALE: 'f',
};

export const ratingTypes = {
    tennis: 'UTR',
    pickleball: 'UTR-P',
    colorBall: 'CBR',
};

export const DefaultRankTypeText = {
    PTT: 'PTT Rank',
    WORLD: 'World',
};

export const gameTypes = {
    SINGLES: 'singles',
    DOUBLES: 'doubles',
};

export const sortParamTypes = {
    PKBRATING: 'pkbRating',
    SINGLESUTR: 'singlesUtr',
    DOUBLESUTR: 'doublesUtr',
    SINGLESPKB: 'singlesPkb',
    DOUBLESPKB: 'doublesPkb',
    UTRP: 'utrp',
    REGDATE: 'regDate',
    NAME: 'name',
    AGE: 'age',
    WTAORDER: 'wtaOrder',
    UTAORDER: 'utrOrder',
    PTS_RANK: 'ptsRank',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    SEED: 'seed',
};

export const filterTypes = {
    PICKLEBALL_FILTER: 'showPickleballFilter',
    TENNIS_FILTER: 'showTenisFilter',
};

export const inAppPurchaseConstants = {
    platform: ['Apple', 'Android'],
    Apple: {
        url: 'https://support.apple.com/en-in/guide/iphone/iph3dfd91de/ios',
        text: 'Subscribed via Apple App Store.',
    },
    Android: {
        url: 'https://support.google.com/accounts/answer/7673989?hl=en&co=GENIE.Platform%3DAndroid',
        text: 'Subscribed via Google Play Store.',
    },
};

export const PlayerProfileTabIdentifiers = {
    OVERVIEW: 1,
    RESULTS: 2,
    EVENTS: 3,
    CLUBS: 4,
    STATS: 6,
    STUDENT_INFO: 7,
};

export const EventProfileTabIdentifiers = {
    OVERVIEW: 1,
    PLAYERS: 2,
    TEAM_STANDINGS: 3,
    DRAWS: 4,
    SCHEDULE: 6,
    DIVISIONS: 7,
    ELIGIBLE_PLAYERS: 8,
    PRE_REG_INVITES: 9,
    LIVE: 10,
};

export const DualMatchTabIdentifiers = {
    RESULTS: 1,
    ROSTER: 2,
};

export const ClubProfileTabIdentifiers = {
    OVERVIEW: 1,
    ROSTER: 2,
    SCHEDULE: 3,
    EVENTS: 4,
    LEAGUES: 5,
    RESULTS: 6,
    MEMBERS: 7,
    COLLEGE_CORNER: 9,
};

export const PopupTypes = {
    ACTIVATE_UTR_UNDER_AGE_POPUP: 'activateUtrUnderAge',
    POWER_UPGRADE_POPUP: 'powerUpgrade',
    POWER_UPGRADE_POPUP_V2: 'powerUpgradeV2',
    POWER_SUCCESS_POPUP_V2: 'powerSuccessV2',
    UPGRADE_TO_POWER_POPUP: 'hotelPlannerUpgrade',
    POWER_UPGRADE_POPUP_V4: 'powerUpgradeV4',
    POWER_MONTHLY_UPGRADE_POPUP: 'powerMonthlyUpgrade',
    POWER_MONTHLY_UPGRADE_SUCCESS_POPUP: 'powerMonthlyUpgradeSuccess',
    NOT_READY_FOR_POWER_POPUP: 'notReadyForPower',
    POWER_RESUME_CONFIRM_POPUP: 'powerResumeConfirm',
};

export const RatingChoiceTypeIds = {
    VERIFIED_SINGLES_UTR: 1,
    VERIFIED_DOUBLES_UTR: 2,
    SINGLES_UTR: 3,
    DOUBLES_UTR: 4,
    UTR: 5,
    PROGRESSION_BALL: 6,
};

export const utrpRangeValuesV2 = {
    P1: 1,
    P2: 2,
    P3: 3,
    P4: 4,
    P5: 5,
};

export const RatingStatuses = {
    RATED: 'Rated',
    INACTIVE: 'Inactive',
    UNRATED: 'Unrated',
    PROJECTED: 'Projected',
    ESTIMATED: 'Estimated',
};

export const RatingChoices = {
    UTR_RATING: 'UTRRating',
    PROGRESSION_BALL_RATING: 'ProgressionBallRating',
};

export const SportTypes = {
    Tennis: 1,
    Pickleball: 2,
};

export const PartnerSelectionChoices = {
    EXISTING: 'existing',
    INVITE: 'invite',
    NEEDS_PARTNER: 'needsPartner',
    ADD_NEEDS_PARTNER: 'addNeedsPartner',
};

export const RestrictAgeByDateTypeIds = {
    EVENTSTARTDATE: 1,
    ENDOFYEAR: 2,
};

export const clientType = 'web';

export const AutoschedulerDrawStartModes = {
    Invalid: 'Invalid',
    UseExactStartTimes: 'UseExactStartTimes',
    UseSuggestedStartTimes: 'UseSuggestedStartTimes',
};

export const SanctionTypes = {
    USAP: 1,
};

export const seedTypeOptions = {
    1: 'By rating',
    2: 'Manual',
    3: 'Random',
};

export const SeoLocations = {
    UNITED_STATES: 'united-states',
    CANADA: 'canada',
};

export const ScreenSizes = {
    MAX_MOBILE_WIDTH: 768,
    MAX_TABLET_WIDTH: 991,
};

export const DataImportTypeIds = {
    USTA_TOURNAMENTS: 3,
    USTA_LEAGUES: 20,
};

export const ScoreUpdateRequestTypes = {
    INCORRECT_SCORE: 1,
    DUPLICATE_SCORE: 2,
};

export const SubscriptionIntervalTypes = {
    YEAR: 'year',
    MONTH: 'month',
};

// Numeric country IDs used by CurrentMemberViewModel.subscriptionBillingCountryId.
export const BillingCountryIds = {
    USA: 216,
};

export const ClubSubtypes = {
    MENS: 1,
    WOMENS: 2,
    COED: 3,
};

export const Power6Types = {
    GENERAL: 'general',
    MEN: 'men',
    WOMEN: 'women',
};

export const POWER6_KEYS = {
    ACTIVE_ROSTER: 'activeRoster.power6.power6Rating',
    ACTIVE_ROSTER_MASKED: 'activeRoster.power6.power6RatingMasked',
    SCHOOL: 'school.power6',
    SCHOOL_MASKED: 'school.power6masked',
};

export const CLASS_YEAR_IDS = {
    FRESHMAN: 1,
    SOPHOMORE: 2,
    JUNIOR: 3,
    SENIOR: 4,
    GRADUATE: 5,
    GRADUATE_STUDENT: 6,
};

export const CLASS_YEAR_ID_TO_STATUS_MAP = {
    1: 'Freshman',
    2: 'Sophomore',
    3: 'Junior',
    4: 'Senior',
    5: 'Graduate',
    6: 'Graduate Student',
};

export const CLASS_YEAR_OPTIONS = [
    { id: 1, label: 'Freshman' },
    { id: 2, label: 'Sophomore' },
    { id: 3, label: 'Junior' },
    { id: 4, label: 'Senior' },
    { id: 5, label: 'Graduate' },
    { id: 6, label: 'Graduate Student' },
];

export const isValidClassYearId = (id) => {
    return id >= 1 && id <= 6 && CLASS_YEAR_ID_TO_STATUS_MAP[id] !== undefined;
};

export const getClassYearStatus = (classYearId) => {
    if (!isValidClassYearId(classYearId)) {
        return null;
    }
    return CLASS_YEAR_ID_TO_STATUS_MAP[classYearId];
};

export const getClassYearIdFromStatus = (classYearStatus) => {
    if (!classYearStatus) {
        return null;
    }
    // Handle redshirt status (e.g., "Redshirt Freshman" -> "Freshman")
    const statusWithoutRedshirt = classYearStatus.replace(/^Redshirt\s+/i, '');
    const entry = Object.entries(CLASS_YEAR_ID_TO_STATUS_MAP).find(
        ([, status]) => status === statusWithoutRedshirt,
    );
    return entry ? parseInt(entry[0], 10) : null;
};

// Get class year options for redshirt dropdown (only Freshman, Sophomore, Junior, Senior)
export const getRedshirtClassYearOptions = () => {
    return CLASS_YEAR_OPTIONS.filter(option => option.id <= CLASS_YEAR_IDS.SENIOR);
};

export const mapClassYearIdForRedshirt = (selectedClassYearId, isRedshirt) => {
    if (isRedshirt && selectedClassYearId === CLASS_YEAR_IDS.SENIOR) {
        // Redshirt Senior = Graduate Student
        return CLASS_YEAR_IDS.GRADUATE_STUDENT;
    }
    return selectedClassYearId;
};

export const mapClassYearIdToDropdown = (classYearId) => {
    if (classYearId === CLASS_YEAR_IDS.GRADUATE_STUDENT) {
        // Graduate Student shows as Senior in dropdown
        return CLASS_YEAR_IDS.SENIOR;
    }
    if (classYearId === CLASS_YEAR_IDS.GRADUATE) {
        // Graduate shows as Senior in dropdown
        return CLASS_YEAR_IDS.SENIOR;
    }
    return classYearId;
};

export const CLUB_PROFILE_VIEW_TYPES = {
    COLLEGE: 'college',
    HIGHSCHOOL: 'highschool',
};

export const SCHOOL_TYPES = {
    HIGH_SCHOOL: 'HS',
    COLLEGE: 'College',
};

export const USER_STATUS_FREE = 'free';
export const USER_STATUS_ANNUAL = 'annual';
export const USER_STATUS_MONTHLY = 'monthly';
export const USER_STATUS_PAST_DUE = 'past_due';
export const defaultPhoneCountryCode = 'US';

// Match status constants for Match cards
export const MatchStatus = {
    COMPLETED: 'completed',
    LIVE: 'live',
    PENDING: 'pending',
    UPCOMING: 'upcoming',

    SUSPENDED: 'suspended',
    INTERRUPTED: 'interrupted',
    STARTS_AT: 'startsAt',
    NOT_BEFORE: 'notBefore',
    FOLLOWED_BY: 'followedBy',
    TBD: 'tbd',
    ABANDONED: 'abandoned',
    IN_PROGRESS: 'In progress',
};

// Position numbers for match card
export const PositionNumbers = {
    POSITION_1: 1,
    POSITION_2: 2,
};

// Status text constants for Match cards
export const StatusText = {
    COMPLETED: 'Completed',
    LIVE: 'Live',
    PENDING: 'Pending',
    SUSPENDED: 'Suspended',
    UPCOMING: 'Upcoming',
    FOLLOWED_BY: 'Followed by',
    NOT_BEFORE: 'Not before',
    STARTS_AT: 'Starts at',
    TBD: 'TBD',
    ABANDONED: 'Abandoned',
};

// Default player name when player data is not available
export const DEFAULT_PLAYER_NAME = 'TBD';

// Menu options for event profile match card (schedule / draws tab)
export const EventProfileMatchCardMenuOptions = {
    EDIT_SCORE: {
        id: 'edit_score',
        label: 'Edit Score',
        value: 'edit_score',
    },
    DELETE_SCORE: {
        id: 'delete_score',
        label: 'Delete Score',
        value: 'delete_score',
    },
};

// Time label prefixes for extracting time from labels
export const TIME_LABEL_PREFIXES = ['Starts at', 'Followed by', 'Not Before'];

// Activity Stats configuration
export const activityTimeframeConfig = {
    allTime: { uiValue: 'AllTime', label: 'All Time', analyticsValue: 'all_time' },
    m12: { uiValue: 'TwelveMonth', label: '12 Month', analyticsValue: '12_month' },
    ytd: { uiValue: 'YTD', label: 'YTD', analyticsValue: 'year_to_date' },
    m6: { uiValue: 'SixMonth', label: '6 Month', analyticsValue: '6_month' },
    m3: { uiValue: 'ThreeMonth', label: '3 Month', analyticsValue: '3_month' },
    m1: { uiValue: 'OneMonth', label: '1 Month', analyticsValue: '1_month' },
};

export const activityTimeOptions = Object.entries(activityTimeframeConfig)
    .map(([apiValue, config]) => ({ value: apiValue, label: config.label }));

export const activityTimeframeApiToUi = Object.entries(activityTimeframeConfig)
    .reduce((acc, [apiValue, config]) => { acc[apiValue.toLowerCase()] = config.uiValue; return acc; }, {});

export const activityTimeframeUiToApi = Object.entries(activityTimeframeConfig)
    .reduce((acc, [apiValue, config]) => { acc[config.uiValue] = apiValue; return acc; }, {});

export const activityGameTypeOptions = [
    { label: 'Singles', value: 'Singles' },
    { label: 'Doubles', value: 'Doubles' },
];

export const activityTennisStatKeys = [
    { key: 'matchesPlayed', title: 'Matches Played' },
    { key: 'setsPlayed', title: 'Sets Played' },
    { key: 'gamesPlayed', title: 'Games Played' },
    { key: 'decisiveSetMatches', title: 'Decisive Set Matches' },
    { key: 'straightSetMatches', title: 'Straight Set Matches' },
    { key: 'tiebreakerSets', title: 'Tiebreaker Sets' },
];

export const activityPickleballStatKeys = [
    { key: 'matchesPlayed', title: 'Matches Played', mobileTitle: 'Matches' },
    { key: 'gamesPlayed', title: 'Games Played', mobileTitle: 'Games' },
    { key: 'pointsPlayed', title: 'Points Played', mobileTitle: 'Points' },
    { key: 'singleGameMatches', title: 'Single Game Matches Played', mobileTitle: 'Single Game Matches' },
    { key: 'multiGameMatches', title: 'Multi-Game Matches Played', mobileTitle: 'Multi-Game Matches' },
];

export const activityDefaultTennisFilters = { matchType: 'Singles', timeFrame: 'allTime', verified: false };
export const activityDefaultPickleballFilters = { matchType: 'Doubles', timeFrame: 'allTime', verified: false };

export const activityStatsSportKeys = {
    TENNIS: 'tennis',
    PICKLEBALL: 'pickleball',
};

export const defaultDistance = '50mi ';
